module.exports = __webpack_public_path__ + "img/weed-logo.df92d441.png";